export default {
  openModal({ commit }, payload) {
    commit('setModals', payload)
  }
}
